import { Link } from '@coop/components';

import { ga4NavigationTracking } from '../../../common/tracking/ga4/navigation';
import styles from './Footer.module.scss';

const FooterColumn = ({ column }: { column: FooterColumn }) => {
    return (
        <div className={styles.FooterColumn}>
            <ul className={styles.FooterList}>
                <li className={styles.FooterHeading}>
                    <h2>
                        <Link
                            href={column.headerLink?.url}
                            onClick={() => {
                                if (column.headerLink?.url && column.header) {
                                    ga4NavigationTracking.footerNavigationClick(
                                        column.header,
                                        column.headerLink?.url,
                                    );
                                }
                            }}
                        >
                            {column.header}
                        </Link>
                    </h2>
                </li>
                {column.links
                    .filter((_link, index) => index > 0)
                    .map((link) => (
                        <li className={styles.FooterItem} key={link.contentId}>
                            <Link
                                size="small"
                                href={link.url}
                                onClick={() => {
                                    if (link.url && link.name) {
                                        ga4NavigationTracking.footerNavigationClick(
                                            link.name,
                                            link.url,
                                        );
                                    }
                                }}
                            >
                                {link.name}
                            </Link>
                        </li>
                    ))}
            </ul>
        </div>
    );
};

export default FooterColumn;
